import { z } from 'zod';

export const auditLogQuerySchema = z.object({
  entityType: z.string().max(60).optional(),
  action: z.string().max(30).optional(),
  from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  limit: z.coerce.number().int().min(1).max(1000).optional(),
});
export type AuditLogQuery = z.infer<typeof auditLogQuerySchema>;

export interface AuditLogEntry {
  id: string;
  entityType: string;
  entityId: string;
  action: string;
  actorOid: string | null;
  before: unknown;
  after: unknown;
  createdAt: string;
}
